<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options" [isValid]="canSave()">
  <div class="user-editor-container editor-container">
    <form class="user-form admin-form">
      <shared-ui-text-input label="Client Name" [control]="form?.clientName"></shared-ui-text-input>
      <shared-ui-text-input label="Okta Client Id" [control]="form?.oktaClientId"></shared-ui-text-input>
      <shared-ui-text-input label="GX URL" [control]="form?.gxURL"></shared-ui-text-input>
      <shared-ui-text-input label="GX Key" [control]="form?.gxKey"></shared-ui-text-input>
      <shared-ui-text-input label="GX Password" [control]="form?.gxPassword"></shared-ui-text-input>
      <shared-ui-text-input label="Power BI URL" [control]="form?.powerBIURL"></shared-ui-text-input>
      <shared-ui-text-input label="Database Connection String" [control]="form?.databaseConnectionString"></shared-ui-text-input>
    </form>
  </div>
</app-modal-wrapper>
